import richtextView from './richtextComponent.html';
import Quill from './Quill';
import './richtextComponent.css';
import _ from 'lodash';

export function richtextComponent() {
	return {
		bindings: {
			htmlTabindex: '@',
			model: '=',
			placeholder: '@',
			toolbar: '@',
			autohideToolbar: '<',
			allowImages: '<?',
			expandableTo: '@?',
		},
		controllerAs: 'vm',
		controller: richtextComponentCtrl,
		template: richtextView,
	};
}

export class richtextComponentCtrl {
	constructor($scope, $element, $timeout) {
		'ngInject';
		this.$element = $element;
		this.$timeout = $timeout;
		this.isFaded = true;
		$scope.$watch('vm.model', newVal => {
			if (typeof newVal != 'string' || this.justSet) {
				this.justSet = false;
				return;
			}
			// Use paste to avoid the error: [Parchment] cannot insert block into inline
			// https://github.com/quilljs/quill/issues/1449
			// First reset the editor to empty
			this.quill.setContents([]);
			// Then initialize the content to exactly what we have
			this.quill.clipboard.dangerouslyPasteHTML(0, newVal);
		});
	}

	$onInit() {
		this.setupQuill();
	}

	getToolbar() {
		const sets = {
			minimal: [
				['bold', 'italic'],
				[{ list: 'ordered' }, { list: 'bullet' }],
				this.allowImages ? ['link', 'image'] : ['link'],
			],
		};
		let toolbar = sets[this.toolbar || 'minimal'];
		if (this.expandableTo) {
			toolbar.push(['expand']);
			toolbar = {
				container: toolbar,
				handlers: { expand: () => {} },
			};
		}
		return toolbar;
	}

	setupQuill() {
		const editor = this.$element[0].querySelector('.quill-editor');
		editor.innerHTML = this.model || '';
		this.quill = new Quill(editor, {
			modules: {
				toolbar: this.getToolbar(),
				history: {
					delay: 1000,
					maxStack: 50,
					userOnly: false,
				},
				imageImport: this.allowImages,
				imageResize: this.allowImages
					? {
							displaySize: true,
					  }
					: false,
				expandEditor: this.expandableTo,
				pasteCleaner: this.allowImages
					? true
					: {
							insert: { image: false },
							attributes: {},
					  },
			},
			placeholder: this.placeholder,
			theme: 'snow',
		});
		this.quill.root.setAttribute('tabindex', this.htmlTabindex || -1);
		const setModel = () => {
			this.$timeout(() => {
				this.model = this.quill.root.innerHTML;
				this.justSet = true;
			});
		};
		this.quill.on('text-change', _.throttle(setModel, 200, { leading: false, trailing: true }));
	}

	handleFocus($type) {
		if ($type == 'focus') {
			this.isFaded = false;
			this.isFocused = true;
		} else {
			this.isFocused = false;
			setTimeout(() => {
				this.isFaded = true;
				this.$timeout(() => {});
			}, 315);
		}
	}
}
